module.exports = __webpack_public_path__ + "img/page-box-2.fb7d10c.jpg";